export default "__VITE_ASSET__DCWzYa5k__"